import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { productTypes } from '../../../types/products';

import { TranslatedCopy } from '../../../intl/TranslatedCopy';

import { H2, H3, ProductGenderDivision, SpacerDot, Currency, Icon, Table } from '../../../components';
import ProductImage from '~COMPONENTS/aurora/ProductImage';

import orderDetailsShipmentColumns from '../orderDetailsShipmentColumns';

import { formatColorString } from '../../../util/formatColorString';
import { getIsGreaterChinaSalesOrg } from '../../../gamedayAccount/selectors';

export const OrderDetailsShipmentProduct = ({ product, shipped, size, full, isGreaterChinaSalesOrg }) => {
  if (!product) return null;

  const {
    productCode,
    colorName,
    copy,
    styleGenderAge,
    division,
    totalShippedQty,
    retailAmount,
    netAmount,
    currencyCode,
    totalNet,
    returnable,
    sizes
  } = product;
  const filteredSizes = sizes
    .filter(currentSize => currentSize.code === size)
    .map(currentSize => ({
      code: currentSize.code,
      totalShippedQty: shipped
    }));
  // --
  const name = copy ? copy.name : '';

  const sum = (array, key) => array && array.reduce((sum, object) => sum + object[key], 0);

  return (
    <div className='orderDetails__shipments_product mb5-sm u-full-width'>
      <div className='orderDetails__shipments_productHeader flex-container column start space-between'>
        <div className='orderDetails__shipments_productInfo flex-container row start'>
          <div className='orderDetails__shipments_productInfo_image p2-sm'>
            <ProductImage alt={name} productCode={productCode} />
          </div>
          <div className='orderDetails__shipments_productInfo_details start ml5-sm'>
            <ul className='body-4 text-color-secondary'>
              <li>
                <H2 className='text-color-primary-dark'>{name}</H2>
              </li>
              <li>
                <p>
                  <ProductGenderDivision gender={styleGenderAge} division={division} />
                </p>
              </li>
              <li>
                <p>
                  <TranslatedCopy id='global.product.style' />
                  {': '}
                  {productCode}
                </p>
              </li>
              <li>
                <p>
                  <TranslatedCopy id='global.product.color' />
                  {': '}
                  {formatColorString(colorName)}
                </p>
              </li>
              <li>
                {full ? (
                  <p>
                    {!isGreaterChinaSalesOrg && (
                      <>
                        <TranslatedCopy id='global.product.retail' />{' '}
                        <Currency value={retailAmount} type={currencyCode} />
                        <SpacerDot />
                      </>
                    )}
                    <TranslatedCopy id='global.product.wholesale.net' />{' '}
                    <Currency value={netAmount} type={currencyCode} />
                  </p>
                ) : (
                  <p>
                    <TranslatedCopy id='orderstatus.qtyInShipment' />
                    {': '}
                    <TranslatedCopy id='global.of.values' values={{ quantity: shipped, total: totalShippedQty }} />
                  </p>
                )}
              </li>
            </ul>
          </div>
        </div>
        {full && (
          <div className='orderDetails__shipments_productFull flex-container headline-5 mt4-sm mt0-md'>
            <H2>
              <TranslatedCopy id='orderreturns.totalQuantity' />
              {': '}
              {shipped}
            </H2>
            <H2>
              <TranslatedCopy id='global.total' />{' '}
              <Currency value={(totalNet / totalShippedQty) * shipped} type={currencyCode} />
            </H2>
            {!returnable && (
              <H3 className='text-color-secondary flex-container row align-center'>
                <Icon
                  name='non-returnable'
                  className='mr1-sm'
                  alt={new TranslatedCopy({ id: 'global.nonReturnable' }).toString()}
                />
                <TranslatedCopy id='global.product.nonReturnable' />
              </H3>
            )}
          </div>
        )}
      </div>
      {full && (
        <div className='orderDetails__shipments_productSizes mt4-sm pb3-sm'>
          <Table
            overrideClass='details__product_table'
            data={filteredSizes}
            columns={orderDetailsShipmentColumns}
            id={productCode}
            headerProps={{
              shipped: sum(filteredSizes, 'totalShippedQty')
            }}
          />
        </div>
      )}
    </div>
  );
};

OrderDetailsShipmentProduct.propTypes = {
  product: productTypes.isRequired,
  shipped: PropTypes.number.isRequired,
  size: PropTypes.string.isRequired,
  full: PropTypes.bool,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired
};

OrderDetailsShipmentProduct.defaultProps = {
  full: false
};

const mapStateToProps = state => ({
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state)
});

export default connect(mapStateToProps, {})(OrderDetailsShipmentProduct);
